import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { CalendarIcon, UserIcon, StethoscopeIcon, CreditCardIcon, FlaskConicalIcon, PillIcon, PackageIcon, BarChart3Icon, MenuIcon, XIcon } from 'lucide-react';
const navItems = [{
  path: '/appointments',
  label: 'Appointments',
  icon: CalendarIcon
}, {
  path: '/patient-portal',
  label: 'Patient Portal',
  icon: UserIcon
}, {
  path: '/doctor-portal',
  label: 'Doctor Portal',
  icon: StethoscopeIcon
}, {
  path: '/billing',
  label: 'Billing & Payments',
  icon: CreditCardIcon
}, {
  path: '/pathology',
  label: 'Pathology',
  icon: FlaskConicalIcon
}, {
  path: '/pharmacy',
  label: 'Pharmacy',
  icon: PillIcon
}, {
  path: '/vendors',
  label: 'Vendor Management',
  icon: PackageIcon
}, {
  path: '/analytics',
  label: 'Analytics',
  icon: BarChart3Icon
}];
export function Navigation() {
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  return <nav className="bg-white border-b border-gray-200 sticky top-0 z-50" data-id="element-599">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-600">
        <div className="flex justify-between h-16" data-id="element-601">
          <div className="flex items-center" data-id="element-602">
            <button onClick={() => navigate('/')} className="flex items-center space-x-2" data-id="element-603">
              <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center" data-id="element-604">
                <StethoscopeIcon className="w-5 h-5 text-white" data-id="element-605" />
              </div>
              <span className="text-xl font-bold text-gray-900" data-id="element-606">ClinicERP</span>
            </button>
          </div>
          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-1" data-id="element-607">
            {navItems.map(item => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            return <button key={item.path} onClick={() => navigate(item.path)} className={`flex items-center space-x-2 px-3 py-2 rounded-md text-sm font-medium transition-colors ${isActive ? 'bg-blue-50 text-blue-700' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-608">
                  <Icon className="w-4 h-4" data-id="element-609" />
                  <span data-id="element-610">{item.label}</span>
                </button>;
          })}
          </div>
          {/* Mobile menu button */}
          <div className="md:hidden flex items-center" data-id="element-611">
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="p-2 rounded-md text-gray-700 hover:bg-gray-100" data-id="element-612">
              {mobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-613" /> : <MenuIcon className="w-6 h-6" data-id="element-614" />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile Navigation */}
      {mobileMenuOpen && <div className="md:hidden border-t border-gray-200" data-id="element-615">
          <div className="px-2 pt-2 pb-3 space-y-1" data-id="element-616">
            {navItems.map(item => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;
          return <button key={item.path} onClick={() => {
            navigate(item.path);
            setMobileMenuOpen(false);
          }} className={`flex items-center space-x-3 w-full px-3 py-2 rounded-md text-base font-medium ${isActive ? 'bg-blue-50 text-blue-700' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-617">
                  <Icon className="w-5 h-5" data-id="element-618" />
                  <span data-id="element-619">{item.label}</span>
                </button>;
        })}
          </div>
        </div>}
    </nav>;
}